// Side pane list filters: element type and connection type, on top of the text
// search. The two narrow each other, so "actuated valve" + "names" lists the
// actuated valves that have a names link and the names links that touch one —
// the way to find, say, valves named by a type code among hundreds of rows.

const idOf = (v) => String((typeof v === 'object' && v?._id) ? v._id : v);

// [{ value, count }] for each distinct `key` among items, most common first.
export function typeCounts(items, key) {
  const counts = new Map();
  for (const item of items) {
    const value = item[key] || '';
    counts.set(value, (counts.get(value) || 0) + 1);
  }
  return [...counts.entries()]
    .map(([value, count]) => ({ value, count }))
    .sort((a, b) => b.count - a.count || a.value.localeCompare(b.value));
}

// elementType / connectionType: '' for any. Returns the elements and
// connections that pass both filters.
export function applyTypeFilters(elements, connections, { elementType = '', connectionType = '' } = {}) {
  if (!elementType && !connectionType) return { elements, connections };
  const ofType = new Set(elementType
    ? elements.filter(e => e.elementType === elementType).map(e => idOf(e._id))
    : []);
  const conns = connections.filter(c =>
    (!connectionType || c.relationshipType === connectionType) &&
    (!elementType || ofType.has(idOf(c.source)) || ofType.has(idOf(c.target))));
  let els = elementType ? elements.filter(e => e.elementType === elementType) : elements;
  if (connectionType) {
    const ends = new Set();
    for (const c of connections) {
      if (c.relationshipType !== connectionType) continue;
      if (c.source) ends.add(idOf(c.source));
      if (c.target) ends.add(idOf(c.target));
    }
    els = els.filter(e => ends.has(idOf(e._id)));
  }
  return { elements: els, connections: conns };
}

// status: 'all' | 'unconfirmed' | 'confirmed'. Rejected items are neither —
// they're only listed under 'all' (and the canvas's "Hide rejected" governs those).
export function matchesStatus(item, status) {
  if (!status || status === 'all') return true;
  if (item.metadata?.rejected) return false;
  return status === 'confirmed' ? !!item.confirmed : !item.confirmed;
}
